import { defaultSiteLanguage } from '@/globalConsts';

export const PATIENT_IDENTIFIER =
	defaultSiteLanguage === 'en-gb' ? 'NHS Number' : 'Patient Identifier';
